import type { CalendarCell } from "../CadenceCalendar.helpers.ts";
import { calendarCellClassName } from "../CadenceCalendar.helpers.ts";

type CalendarGridProps = {
  cells: CalendarCell[];
  selectedDate: string;
  onSelectDate: (date: string) => void;
  onDropTask: (taskId: number, date: string) => void;
};

const WEEKDAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"];

export function CalendarGrid({ cells, selectedDate, onSelectDate, onDropTask }: CalendarGridProps) {
  return (
    <section className="cadence-calendar" aria-label="Calendario mensal">
      <div className="cadence-weekdays">
        {WEEKDAYS.map((day) => <span key={day}>{day}</span>)}
      </div>
      <div className="cadence-calendar-grid">
        {cells.map((cell) => {
          const pending = Number(cell.summary?.pending || 0);
          const late = Number(cell.summary?.late || 0);
          return (
            <button
              key={cell.date}
              type="button"
              className={calendarCellClassName(cell, selectedDate)}
              onClick={() => onSelectDate(cell.date)}
              onDragOver={(event) => event.preventDefault()}
              onDrop={(event) => {
                event.preventDefault();
                const taskId = Number(event.dataTransfer.getData("text/x-cadence-task-id"));
                if (taskId) onDropTask(taskId, cell.date);
              }}
              aria-pressed={cell.date === selectedDate}
            >
              <span className="cadence-day-number">{cell.dayNumber}</span>
              {pending ? <span className="cadence-day-count">{pending}</span> : null}
              {late ? <span className="cadence-day-late">{late} atrasado</span> : null}
            </button>
          );
        })}
      </div>
    </section>
  );
}
